import { create } from "zustand";
import { getProducts } from "../services/api";

const useAdminProductStore = create((set, get) => ({
	products: [],
	hydrated: false,
	loading: false,
	error: "",

	hydrateProducts: async () => {
		if (get().loading || get().hydrated) {
			return;
		}

		set({ loading: true, error: "" });

		try {
			const data = await getProducts();
			set({
				products: Array.isArray(data) ? data : [],
				hydrated: true,
				loading: false,
				error: "",
			});
		} catch (err) {
			set({
				products: [],
				hydrated: false,
				loading: false,
				error: err?.message || "Failed to load products",
			});
		}
	},

	resetProducts: () =>
		set({
			products: [],
			hydrated: false,
			loading: false,
			error: "",
		}),
}));

export default useAdminProductStore;